module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-studio-e16951733e41cefc0b0af1e4fc71bb0b.png";